import { Check } from 'lucide-react';
import styles from './DropdownMenu.module.scss';

type DropdownItemProps = {
    label: string;
    value: string;
    onClick: (value: string | number) => void;
    isSelected: boolean;
};

export const DropdownItem = ({ label, value, onClick, isSelected }: DropdownItemProps) => {
    return (
        <div className={styles.menuItem} onClick={() => onClick(value)} role='menuitem' data-value={value}>
            {isSelected ? <Check size={16} color='var(--primary-purple)' /> : <span />} {label}
        </div>
    );
};
